import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from 'react-query';
import { Dropdown } from 'semantic-ui-react';
import { virtkbd } from '../../../utils';
import * as API from '../../API';
import './KbYearSelector.scss';
export const KbYearSelector = ({ className, preventDefault, stayInFocus, scrollTop = true, onSelect, onClick, prompt, value, pathTemplate = '#totalrangering//{aar}' }) => {
    var _a, _b, _c, _d, _e;
    // Construct regular expression from pathTemplate to extract current field value
    const fieldName = (_b = (_a = pathTemplate.match(/\{([^}]+)\}/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : 'aar';
    const pattern = `${pathTemplate.replace(`{${fieldName}}`, '(\\d{4})')}`;
    const r = new RegExp(pattern);
    let currentSelection = value !== null && value !== void 0 ? value : ((_d = (_c = window.location.hash.match(r)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : '');
    const { data: codeListData } = useQuery('kb/kodeliste', API.fetchCodeList);
    const opts = (_e = codeListData === null || codeListData === void 0 ? void 0 : codeListData.utgaver.map((aar, index) => ({
        key: aar.toString(),
        value: aar.toString(),
        text: index === 0 ? `Nyeste dataår (${aar})` : `Dataåret ${aar}`
    }))) !== null && _e !== void 0 ? _e : [];
    const onSelectYear = (event, data) => {
        if (!preventDefault) {
            if (data.value) {
                let locHash = pathTemplate.replace(`{${fieldName}}`, data.value);
                if (scrollTop === false) {
                    locHash += "?noscroll";
                }
                window.location.hash = locHash;
            }
            if (!stayInFocus || virtkbd()) {
                requestAnimationFrame(() => {
                    document.querySelector('.kb-labfront .kb-year-selector').focus();
                });
            }
        }
        if (onSelect) {
            onSelect(data.value);
        }
    };
    const clsx = [
        'page-element',
        'kb-selector',
        'kb-year-selector',
        className !== null && className !== void 0 ? className : ''
    ].join(' ');
    return (_jsx("div", { className: clsx, tabIndex: -1, children: _jsx(Dropdown, { placeholder: prompt !== null && prompt !== void 0 ? prompt : "Velg år", fluid: true, selection: true, value: currentSelection, options: opts, onChange: onSelectYear, onClick: onClick }) }));
};
